w<template>
    <div>
        <VueDropzone
            id="dropzone"
            ref="myVueDropzone"
            :options="dropzoneOptions"
            @vdropzone-success="success"
        />
    </div>
</template>

<script>
import VueDropzone from 'vue2-dropzone';

export default {
    components: {
        VueDropzone,
    },
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: null,
        },
    },
    computed: {
        fieldValue: {
            get() {
                return this.value;
            },
            set(field) {
                this.$emit('input', field);
            },
        },
        dropzoneOptions() {
            return {
                url: '/api/media',
                uploadMultiple: false,
            };
        },
    },
    methods: {
        success(file, response) {
            this.fieldValue = response.url;
        },
    },
};
</script>
